import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceCategoryForm from '../containers/ResourceCategoryFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceCategoryAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceCategoryAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resource_category_route_add')} />
          <ResourceCategoryForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceCategoryAddScreen;

Logger.log('silly', `ResourceCategoryAddScreen loaded.`);